import { render } from "./AccountCreationForm.vue?vue&type=template&id=5442694e"
import script from "./AccountCreationForm.vue?vue&type=script&lang=js"
export * from "./AccountCreationForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/princes-trust.ac.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__